import { InjectionToken } from '@angular/core';

import { AddressNew } from '@erm/cluster';
import { _constructAddressString } from '@data-access/organizations';

import {
  ContactDetail,
  ContactState,
  ContactInfo,
  ContactWrapper,
} from '../types';

export const contactInitialState: ContactState = {
  canCloseDialog: false,
  countriesTotal: 0,
  data: {} as ContactDetail,
  error: null,
  loading: true,
  roles: {
    data: [],
    total: 0,
  },
  userAttributes: [],
  statesTotal: 0,
};

export const CONTACT_DETAIL_STATE = new InjectionToken<ContactState>(
  'Contact Detail State',
  {
    factory: () => ({ ...contactInitialState }),
  },
);

export const removeMailingAddressDialogData = (
  address: AddressNew,
  canRemove: boolean,
) => {
  const _description = canRemove
    ? `Are you sure you want to remove ${_constructAddressString(address)}?`
    : `${_constructAddressString(address)} is a primary address. Make another address a primary address before removing this address`;

  return {
    buttons: {
      cancelButtonText: canRemove ? 'Cancel' : '',
      cancelColor: 'tertiary',
      deleteButtonText: canRemove ? 'Remove' : 'Okay',
      primaryColor: canRemove ? 'primary-warn' : 'primary',
    },
    description: _description,
    title: 'Remove Physical Address',
    type: 'MESSAGE',
  };
};

export const DEFAULT_CONTACT_INFO: ContactInfo = {
  id: '',
  type: 'phone',
  contact: '',
  countryCode: { id: '', label: '', value: '' },
  isPrimary: false,
};

export const CONTACT_TYPE_ENUM = {
  phone: 'phone',
  email: 'email',
  fax: 'fax',
  other: 'other',
};

export const CONTACT_WRAPPER_DEFAULT: ContactWrapper = {
  contactForm: DEFAULT_CONTACT_INFO,
  assignedContacts: [],
};

export const determineContactWrapperDefault = (
  contactType: 'phone' | 'email',
): ContactInfo => {
  return {
    ...DEFAULT_CONTACT_INFO,
    type: contactType,
  };
};

/*
 * @NOTE: SCHEMA VALIDATIONS START
 *
 * */

/**
 *
 * @NOTE: SCHEMA VALIDATIONS END
 *
 * */
